module.exports = __webpack_public_path__ + "media/images/home/screen_68-721a659c5141b264d787e46d03ff5965.png";